import { Panel, PanelType as FluentPanelType } from "@fluentui/react";
import { useState } from "react";
import PanelHeader from "components/shared/panel/PanelHeader";
import PolicyPropertiesForm from "components/policy/PolicyPropertiesForm";
import PolicyPanelActions from "components/policyPanel/PolicyPanelActions";
import stringsConst from "consts/strings";
import usePolicyPanel from "hooks/policy/usePolicyPanel";
import { IPanel, IPanelProps, PanelType } from "models/panel";
import { PolicyEditState } from "models/policyPanel";

const getPolicyPanelInfo = (panelInfo: IPanel) => ({
  editState:
    (panelInfo.additionalInfo.policyEditState as PolicyEditState) ||
    PolicyEditState.Default,
  policyId: panelInfo.agreementObjectIds.policyId,
});

// eslint-disable-next-line react/function-component-definition
const PolicyPanel = ({ panelInfo, isBlocking }: IPanelProps) => {
  const policyPanelInfo = getPolicyPanelInfo(panelInfo);
  const isPanelOpen = panelInfo.panelType === PanelType.Policy;
  const { closePanel } = usePolicyPanel();
  
  // Local state for form fields until Redux slice is implemented
  const [formValues, setFormValues] = useState({
    policyType: "Implicit Acceptance",
    policyName: "",
    description: "",
  });

  const onClosePanel = () => {
    // TODO: Handle unsaved changes dialog if needed
    closePanel();
  };

  const panelStyles = {
    scrollableContent: {
      display: 'flex',
      flexDirection: 'column' as const,
      height: '100%',
    },
    content: {
      paddingTop: "20px",
      flexGrow: 1,
      overflow: 'auto' as const,
    },
  };

  const isNewPolicy = policyPanelInfo.editState === PolicyEditState.NewPolicy;
  const panelTitle = isNewPolicy
    ? "Create new policy"
    : `Policy ${policyPanelInfo.policyId}`;

  return (
    <Panel
      styles={panelStyles}
      hasCloseButton={false}
      isFooterAtBottom
      type={FluentPanelType.custom}
      customWidth="500px"
      isOpen={isPanelOpen}
      closeButtonAriaLabel={stringsConst.common.closeButtonAriaLabel}
      isBlocking={isBlocking}
      // eslint-disable-next-line react/no-unstable-nested-components
      onRenderHeader={() => (
        <PanelHeader title={panelTitle} onClosePanel={onClosePanel} />
      )}
      // eslint-disable-next-line react/no-unstable-nested-components
      onRenderFooter={() => (
        <PolicyPanelActions
          editState={policyPanelInfo.editState}
          onClosePanel={onClosePanel}
          formValues={formValues}
        />
      )}
    >
      <PolicyPropertiesForm
        editState={policyPanelInfo.editState}
        formValues={formValues}
        setFormValues={setFormValues}
      />
    </Panel>
  );
};

export default PolicyPanel;